import { RolePolicies } from "@/domain/user"

export const rolePolicies: RolePolicies = {
  OPERATOR: {
    issues: ["write"],
    tickets: ["write"],
    labels: ["write"],
    reports: ["write"]
  },
  TICKET_CREATOR: {
    tickets: ["write"],
    reports: ["write"]
  },
  VIEWER: {
    reports: ["write"]
  }
}
